import * as D3 from 'd3';
import React, { useEffect, useRef } from 'react';

export default ({ data, setData }) => {
  const d3Container = useRef(null);
  useEffect(() => {
    const lineY = 20;
    const svg = D3.select(d3Container.current);
    svg
      .attr('height', '100%')
      .attr('width', '100%');
    svg.selectAll('*').remove();
    const group = svg.append('g');
    const heightBar = 12;
    group.append('rect')
      .attr('x', '0')
      .attr('y', lineY - (heightBar / 2))
      .attr('height', heightBar)
      .attr('width', '100%')
      .attr('fill', '#DEE2E6')
      .attr('rx', 6)
      .attr('ry', 6);

    const dragStart = { first: 0, second: 0, lastFirstPercent: data.first, lastSecondPercent: data.second };
    const pointerHighlight = group.append('circle')
      .attr('cy', lineY)
      .attr('r', 17)
      .attr('fill', '#B2D3F6')
      .attr('style', 'display: none');
    const barHighlight = group.append('rect')
      .attr('x', data.first + '%')
      .attr('y', lineY - (heightBar / 2))
      .attr('height', heightBar)
      .attr('width', (data.second - data.first) + '%')
      .attr('fill', '#B2D3F6');
    const pointerA = group.append('circle')
      .attr('cx', data.first + '%')           // position the x-center
      .attr('cy', lineY)           // position the y-center
      .attr('r', 12)
      .attr('fill', '#007BFF')
      .attr('stroke-width', 2)
      .call(D3.drag()
        .on('start', (event) => {
          pointerA.raise().attr('stroke', 'white');
          const cx = pointerA.attr('cx').split('%');
          let pointX = +cx[0];
          if (cx.length > 1) {
            const viewWidth = d3Container.current ? d3Container.current.clientWidth : 0;
            pointX = (+cx[0] * viewWidth) / 100;
          }
          dragStart.first = +event.x - pointX;
          pointerHighlight.attr('cx', pointerA.attr('cx')).attr('style', 'display: unset');
        })
        .on('drag', (event) => {
          const viewWidth = d3Container.current ? d3Container.current.clientWidth : 0;
          const percentage = (event.x - dragStart.first) * 100 / viewWidth;
          if (percentage >= 0 && percentage < data.second) {
            dragStart.lastFirstPercent = percentage;
            pointerA.attr('cx', (event.x - dragStart.first));
            barHighlight.attr('x', percentage + '%').attr('width', (data.second - percentage) + '%');
          }
          pointerHighlight.attr('cx', pointerA.attr('cx'));
        })
        .on('end', () => {
          setData({ ...data, first: dragStart.lastFirstPercent });
          pointerA.attr('stroke', 'none');
          pointerHighlight.attr('style', 'display: none');
        })
      );
    const pointerB = group.append('circle')
      .attr('cx', data.second + '%')           // position the x-center
      .attr('cy', lineY)           // position the y-center
      .attr('r', 12)
      .attr('fill', '#007BFF')
      .attr('stroke-width', 2)
      .call(D3.drag()
        .on('start', (event) => {
          pointerB.raise().attr('stroke', 'white');
          const cx = pointerB.attr('cx').split('%');
          let pointX = +cx[0];
          if (cx.length > 1) {
            const viewWidth = d3Container.current ? d3Container.current.clientWidth : 0;
            pointX = (+cx[0] * viewWidth) / 100;
          }
          dragStart.second = +event.x - pointX;
          pointerHighlight.attr('cx', pointerB.attr('cx')).attr('style', 'display: unset');
        })
        .on('drag', (event) => {
          const viewWidth = d3Container.current ? d3Container.current.clientWidth : 0;
          const percentage = (event.x - dragStart.second) * 100 / viewWidth;
          if (percentage > data.first && percentage <= 100) {
            dragStart.lastSecondPercent = percentage;
            pointerB.attr('cx', (event.x - dragStart.second));
            barHighlight.attr('width', (percentage - data.first) + '%');
          }
          pointerHighlight.attr('cx', pointerB.attr('cx'));
        })
        .on('end', () => {
          setData({ ...data, second: dragStart.lastSecondPercent });
          pointerB.attr('stroke', 'none');
          pointerHighlight.attr('style', 'display: none');
        })
      );
  }, [data]);
  return (
    <svg
      className="d3-component"
      style={{ overflow: 'visible' }}
      ref={d3Container}
    />
  );
};
